import React, { type PropsWithChildren } from 'react';

import { AssistantHost } from '../../components/assistant/AssistantHost';
import { BillingReturnListener } from '../../components/billing/BillingReturnListener';
import { AppleIapHost } from '../../components/billing/AppleIapHost';
import { JoinInviteListener, JoinInviteProvider } from '../../components/household/JoinInviteListener';
import { NotificationHost } from '../../components/notifications/NotificationHost';
import { TelemetrySync } from '../../components/telemetry/TelemetrySync';
import { PortfolioAccountSheetHost } from '../../components/wealth/PortfolioAccountSheetHost';
import { AssistantProvider } from '../../contexts/AssistantContext';
import { AssumedReturnProvider } from '../../contexts/AssumedReturnContext';
import { AuthProvider } from '../../contexts/AuthContext';
import { HouseholdProvider } from '../../contexts/HouseholdContext';
import { HouseholdMembershipProvider } from '../../contexts/HouseholdMembershipContext';
import { ImportOnboardingProvider } from '../../contexts/ImportOnboardingContext';
import { LiabilityProvider } from '../../contexts/LiabilityContext';
import { NotificationProvider } from '../../contexts/NotificationContext';
import { OAuthProvider } from '../../contexts/OAuthProvider';
import { OnboardingProvider } from '../../contexts/OnboardingContext';
import { PortfolioProvider } from '../../contexts/PortfolioContext';
import { SampleDataProvider } from '../../contexts/SampleDataContext';

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <AuthProvider>
      <TelemetrySync />
      <NotificationProvider>
        <BillingReturnListener />
        <AppleIapHost />
        <OAuthProvider>
          <HouseholdProvider>
            <HouseholdMembershipProvider>
              <SampleDataProvider>
                <AssumedReturnProvider>
                  <OnboardingProvider>
                    <PortfolioProvider>
                      <LiabilityProvider>
                        <JoinInviteProvider>
                          <ImportOnboardingProvider>
                            <AssistantProvider>
                              <PortfolioAccountSheetHost />
                              {children}
                              <JoinInviteListener />
                              <NotificationHost />
                              <AssistantHost />
                            </AssistantProvider>
                          </ImportOnboardingProvider>
                        </JoinInviteProvider>
                      </LiabilityProvider>
                    </PortfolioProvider>
                  </OnboardingProvider>
                </AssumedReturnProvider>
              </SampleDataProvider>
            </HouseholdMembershipProvider>
          </HouseholdProvider>
        </OAuthProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}
